import api from "./api";

export default {
    dashboard:() => {
        return api.get(`v1/admin/dashboard`)
    },
}